<template>
  <div class="email-list">
    <el-form
      :inline="true"
      :model="formInline"
      ref="formInline"
      class="demo-form-inline"
    >
      <el-form-item label="职位名称" prop="positionName">
        <el-input
          v-model="formInline.positionName"
          placeholder="职位名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="招聘城市" prop="city">
        <el-input v-model="formInline.city" placeholder="招聘城市"></el-input>
      </el-form-item>
      <el-form-item label="语言类型" prop="languageType">
        <el-select v-model="formInline.languageType" placeholder="语言类型">
          <el-option label="中文" :value="0"></el-option>
          <el-option label="英文" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否发布" prop="isPublish">
        <el-select v-model="formInline.isPublish" placeholder="是否发布">
          <el-option label="全部" value=""></el-option>
          <el-option label="未发布" :value="0"></el-option>
          <el-option label="发布" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button>
        <el-button type="primary" @click="onAdd">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="序号" type="index" width="100"></el-table-column>
      <el-table-column
        prop="positionName"
        label="职位名称"
        width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="companyLabel"
        label="所属公司"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="city"
        label="招聘城市"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payment"
        label="薪酬"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dateStart"
        label="开始时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dateEnd"
        label="结束时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="languageTypeLabel"
        label="语言类型"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isPublishLabel"
        label="是否发布"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="onSent(scope.row)"
            type="text"
            size="small"
            v-if="!scope.row.isPublish"
          >
            发布
          </el-button>
          <el-button
            @click.native.prevent="onUnPub(scope.row)"
            type="text"
            size="small"
            v-else
          >
            下架
          </el-button>
          <el-button
            @click.native.prevent="onEdit(scope.row)"
            type="text"
            size="small"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="onDel(scope.row)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <AddEdit
      v-model="isShow"
      :infoFrom="infoFrom"
      @on-update="onUpdate"
    ></AddEdit>
  </div>
</template>

<script>
import moment from "moment";
import AddEdit from "./edit-add";
import { GetOfferList, DelOffer, PostPubOffer, PostOutOffer } from "../../api/offer";

export default {
  name: "list",
  components: { AddEdit },
  data() {
    return {
      isShow: false,
      tableData: [],
      infoFrom: {},
      formInline: {
        positionName: "",
        city: "",
        languageType: 0,
        isPublish: "",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  methods: {
    init() {
      GetOfferList(this.formInline).then((res) => {
        if (res.status) {
          res.data.dataList.forEach((item) => {
            item.dateStart = moment(item.dateStart).format(
              "YYYY-MM-DD hh:mm:ss"
            );
            item.dateEnd = moment(item.dateEnd).format("YYYY-MM-DD hh:mm:ss");
            item.languageTypeLabel = item.languageType ? "英文" : "中文";
            item.isPublishLabel = item.isPublish ? "发布" : "未发布";
            item.companyLabel =
              item.companyId === 1
                ? "苏州科林利康医药科技有限公司"
                : item.companyId === 2
                ? "美达临床数据技术有限公司"
                : "科睿克（北京）临床医学研究有限公司";
          });
          this.total = res.data.total;
          this.tableData = res.data.dataList || [];
        }
      });
    },
    onSubmit() {
      this.formInline.pageNum = 1;
      this.init();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.init();
    },
    onUpdate() {
      this.init();
    },
    onAdd() {
      this.infoFrom = {};
      this.isShow = true;
    },
    onEdit(params) {
      this.infoFrom = params;
      this.isShow = true;
    },
    onDel(params) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelOffer(params.positionId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.init();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSent(cell) {
      this.$confirm("确定发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          PostPubOffer(cell.positionId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "发布成功!",
              });
              this.init();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 下架
    onUnPub(cell) {
      this.$confirm("确定下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          PostOutOffer(cell.positionId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "下架成功!",
              });
              this.init();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.pager-wrapper {
  margin-top: 10px;
  text-align: right;
}
</style>
